import Stack from "@mui/material/Stack";
import { useRouter } from "next/router";
import { buildLocaleRecord, getIsoLocale, getLocalesFromIsoLocale, Locales } from "@simplyk/common";

import { DashboardButton } from "@/dashboard-design-system/DashboardButton";
import { DashboardTypography } from "@/dashboard-design-system/Typography/DashboardTypography";

interface LoadErrorCopy {
  title: string;
  body: string;
  reload: string;
}

const LOAD_ERROR_COPY = buildLocaleRecord<LoadErrorCopy>({
  [Locales.EN]: {
    title: "We couldn't load the dashboard",
    body: "Reload the page to try again.",
    reload: "Reload page",
  },
  [Locales.FR]: {
    title: "Le tableau de bord n'a pas pu être chargé",
    body: "Veuillez recharger la page pour réessayer.",
    reload: "Recharger la page",
  },
  [Locales.DE]: {
    title: "Das Dashboard konnte nicht geladen werden",
    body: "Bitte laden Sie die Seite neu, um es erneut zu versuchen.",
    reload: "Seite neu laden",
  },
  [Locales.ES]: {
    title: "No se pudo cargar el panel",
    body: "Vuelva a cargar la página para intentarlo de nuevo.",
    reload: "Volver a cargar la página",
  },
});

export const ClientTranslationsLoadError = () => {
  const { locale } = useRouter();
  const copy = LOAD_ERROR_COPY[getLocalesFromIsoLocale(getIsoLocale(locale ?? "en"))];

  return (
    <Stack
      alignItems="center"
      justifyContent="center"
      gap={2}
      sx={{
        height: "100vh",
        ["@supports (height: 100dvh)"]: { height: "100dvh" },
        paddingX: 2,
        textAlign: "center",
      }}
    >
      <DashboardTypography variant="h5" component="p">
        {copy.title}
      </DashboardTypography>
      <DashboardTypography variant="body1">{copy.body}</DashboardTypography>
      <DashboardButton variant="filled" vibe="brand" onClick={() => window.location.reload()}>
        {copy.reload}
      </DashboardButton>
    </Stack>
  );
};
